// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import CarouselResponsive from '@tcp/core/src/components/common/molecules/Carousel/views/CarouselResponsive';
import { applyAspectRatioBoxStyles, applyAspectRatioBoxInsideStyles } from '@tcp/core/src/utils';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';

const getCarouselPadding = (props) => {
  const { carouselPadding: { padding = 0 } = {} } = props || {};
  return `padding: 0 ${padding}px`;
};

const StyledCarousal = styled(CarouselResponsive)`
  .control-arrow {
    background-size: 100% 100%;
    height: 42px;
    width: 13px;
    z-index: 1;
  }
  .control-dots {
    bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_2};
    z-index: 1;
  }
  .tcp_carousel__play_pause_button {
    margin-top: -55px;
    bottom: auto;
    z-index: 1;
  }
  @media only screen and (max-width: 767px) {
    .control-arrow.control-prev,
    .control-arrow.control-next {
      display: none;
    }
  }

  ${(props) => getCarouselPadding(props)}
`;

const applyHeight = (tileHeightValue, subValue = 27, isFullWidthTile) => {
  if (tileHeightValue && !isFullWidthTile) {
    return `height: calc(${tileHeightValue}px - ${subValue}px) !important;`;
  }
  return ``;
};

const StyledImage = styled.div`
  ${(props) => (props.onScrollIdentifier ? `height: 400vh` : '')};
  ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'MOBILE')}
  ${(props) =>
    props.isInGridPromo
      ? `
        ${props.isDoubleTile || props.isFullWidthTile ? `` : `padding-top: 22px;`};
        max-height: 400px;
        [class*="byom-media-grid-promo"], video {
          ${applyHeight(props.tileHeightValue, 22, props.isFullWidthTile)};
        }
      `
      : ``}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'TABLET')}

    ${(props) =>
      props.isInGridPromo
        ? `
        ${props.isFullWidthTile ? `` : `padding-top: 22px;`};
        max-height: 400px;
        [class*="byom-media-grid-promo"], video {
          ${applyHeight(props.tileHeightValue, 24, props.isFullWidthTile)};
        }
      `
        : ``}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'DESKTOP')}

    ${(props) =>
      props.isInGridPromo
        ? `
        ${props.isFullWidthTile ? `` : `padding-top: 30px;`};
        max-height: 500px;
        [class*="byom-media-grid-promo"] {
          ${applyHeight(props.tileHeightValue, 34, props.isFullWidthTile)};
        }
        video {
          ${applyHeight(props.tileHeightValue, 45, props.isFullWidthTile)};
        }
      `
        : ``}
  }
`;

const StyledDamImage = styled(DamImage)`
  ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'DESKTOP')}
  }
`;

const StyledSlideCTAItems = styled.div`
  @media ${(props) => props.theme.mediaQuery.medium} {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .stacked-cta-wrapper-class.stacked-cta-wrapper-class {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
`;

const StyledCTASlideContainer = styled.div`
  @media ${(props) => props.theme.mediaQuery.medium} {
    position: relative;
  }
`;

export default css`
  .medium_text_regular {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs20};
    }
  }

  .carousel-image-layout {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }

  .carousel-cta-button {
    margin-bottom: 0;
  }

  .carousel img {
    pointer-events: auto !important;
  }

  .single-image {
    position: relative;
  }

  .carousel-cta-link {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 54px;
  }

  .module-container-img-full-width {
    width: 100%;
    vertical-align: middle;
  }

  .video-js .vjs-tech {
    vertical-align: middle;
  }
`;

export {
  StyledCarousal as Carousel,
  StyledImage,
  StyledDamImage as DamImage,
  StyledSlideCTAItems,
  StyledCTASlideContainer,
};
